<template>
  <div
    v-if="showConsent"
    class="fixed bottom-0 left-0 right-0 bg-base-200 shadow-lg p-4 z-50 border-t border-base-300 transform transition-transform duration-300"
    :class="{ 'translate-y-0': showConsent, 'translate-y-full': !showConsent }"
  >
    <div class="container mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="flex-1">
        <p class="text-base-content">
          {{ t('cookieConsent.message') }}
          <router-link to="/cookie-policy" class="link link-primary">{{ t('cookieConsent.policyLink') }}</router-link>
          {{ t('cookieConsent.moreInfo') }}
        </p>
      </div>
      <div class="flex flex-wrap gap-2">
        <button
          @click="acceptCookies"
          class="btn btn-primary btn-sm"
        >
          {{ t('cookieConsent.accept') }}
        </button>
        <button
          @click="declineCookies"
          class="btn btn-outline btn-sm"
        >
          {{ t('cookieConsent.decline') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import useLocale from '../compositions/useLocale';

const { t } = useLocale();
const showConsent = ref(false);

const acceptCookies = () => {
  localStorage.setItem('cookie-consent', 'accepted');
  showConsent.value = false;
};

const declineCookies = () => {
  localStorage.setItem('cookie-consent', 'declined');
  showConsent.value = false;
};

onMounted(() => {
  const consentChoice = localStorage.getItem('cookie-consent');

  if (!consentChoice) {
    setTimeout(() => {
      showConsent.value = true;
    }, 1000);
  }
});
</script>
